import { FC } from 'react'

import SafetyCaseStatusFormFields from './safety-case-status-form-fields'

import { ISafetyCaseStatusFormProps } from './safety-case-status-form-types'

const SafetyCaseStatusForm: FC<ISafetyCaseStatusFormProps> = props => {
  const { handleSubmit, formName, submitting, initialValues } = props

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <SafetyCaseStatusFormFields disabled={submitting} isIsActiveDisabled={initialValues.baseStatus !== 2} />
    </form>
  )
}

export default SafetyCaseStatusForm
